module.exports = __webpack_public_path__ + "img/smart-infrastructure-depth1.9cdb9d2c.webp";